export default "__VITE_ASSET__DKn70YUW__"